<template>
  <div>
    <Table
      class="c-form__input"
      size="small"
      border
      stripe
      highlight-row
      :columns="column"
      :data="dicts.TxtFormat"
    >
    </Table>
    <c-form ref="form" :form-model.sync="formModel"></c-form>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import Form from "@/views/schools/form/txt-format/form";

@Component({
  components: {
    "c-form": Form
  },
  props: {
    formModel: {
      type: Object,
      default: () => ({})
    }
  }
})
export default class TxtFormat extends Vue {
  data() {
    return {
      column: [
        {
          title: "码值",
          key: "value"
        },
        {
          title: "标题",
          width: 100,
          key: "label"
        },
         {
          title: "显示标题",
          width: 100,
          key: "text",
          render: (h, { row }) => {
            console.log(this.formModel,row.value);
            return h("span", this.formModel.txtformat[row.value]['text'] || '==')
          }
        },
        {
          title: "操作",
          width: 90,
          render: (h, { row }) =>
            h(
              "Button",
              {
                props: {
                  size: "small"
                },
                on: {
                  click: () => {
                    this.$refs.form.show(row);
                  }
                }
              },
              "设置"
            )
        }
      ]
    };
  }
}

</script>
